import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
export default function getDatePartValue(dateParts, key) {
  var datePart = _findInstanceProperty(dateParts).call(dateParts, function (p) {
    return p.type.toUpperCase() === key.toUpperCase();
  });
  if (datePart) return datePart.value;
  return '';
}